import { useGetRequest, RequestResponse } from "../../hook/useRequest";
import { AppSettings } from "../../AppSettings";
import { getToken } from "../../utils/storage/Token";
import axios from "axios";

const API_URL_EXPLORER = AppSettings.API_FREELANCERIE + "/explorer";

const useFetchExplorer = (id_user: number, forceUpdated = 0): RequestResponse => {
    const config = { headers: { Authorization: getToken() } };
    return useGetRequest(`${API_URL_EXPLORER}/${id_user.toString()}`, forceUpdated, config);
};

/**
 * Télécharge l'archive ZIP de l'arborescence complète de l'utilisateur.
 */
const DownloadExplorerArchive = async (idUser: number): Promise<void> => {
    const url = `${API_URL_EXPLORER}/archive/${idUser}`;
    const response = await axios(url, {
        method: "GET",
        headers: { Authorization: getToken() },
        responseType: "blob",
    });
    const blob = new Blob([response.data], { type: "application/zip" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    const dateLabel = new Date().toISOString().slice(0, 10);
    link.download = `Mes_fichiers_${dateLabel}.zip`;
    link.click();
    URL.revokeObjectURL(link.href);
};

export { useFetchExplorer, DownloadExplorerArchive };
